var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"40px 0 0px 0"},attrs:{"id":"payment-and-refill"}},[_c('div',{staticClass:"upper-content"},[_c('lines-card',{attrs:{"fetchedBefore":true,"data":_vm.lineCard}}),_c('additional-info-card',{attrs:{"type":"animated","fetchedBefore":true,"data":_vm.data.additionalInfo}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }